import { render, staticRenderFns } from "./AppButtonFav.vue?vue&type=template&id=0dd1b775&scoped=true&"
import script from "./AppButtonFav.vue?vue&type=script&lang=js&"
export * from "./AppButtonFav.vue?vue&type=script&lang=js&"
import style0 from "./AppButtonFav.vue?vue&type=style&index=0&id=0dd1b775&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd1b775",
  null
  
)

export default component.exports